module.exports = __webpack_public_path__ + "img/rtb.9fd2d72c.png";